import React, { useMemo } from 'react';
import { ListingCard } from '../../../components';
import Slider from 'react-slick';

import css from './Section.module.css';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';
import { isArrayLength } from '../../../util/genericHelpers';

function ExploreSection(props) {
  const { intl, sliderSettings: sliderSettingsProp, listings = [], user } = props;

  const isWindowDefined = typeof window !== 'undefined';
  const isMobileLayout = isWindowDefined && window.innerWidth < 768;

  const title = intl?.formatMessage?.({
    id: 'ExploreSection.featuredListings',
    defaultMessage: 'Featured Listings',
  });

  const sliderSettings = useMemo(() => {
    const base = ExploreSection.defaultProps.sliderSettings;

    // ✅ merge base + incoming props so `responsive` is never lost
    const merged = {
      ...base,
      ...(sliderSettingsProp || {}),
      responsive: sliderSettingsProp?.responsive || base.responsive,
    };

    // ✅ hard force mobile
    if (isMobileLayout) {
      Object.assign(merged, {
        dots: false,
        arrows: false, // optional (looks better on mobile)
        slidesToShow: 1.2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
      });
    }

    return merged;
  }, [sliderSettingsProp, isMobileLayout]);

  if (!isArrayLength(listings)) {
    return null;
  }

  return (
    <div className={css.popularSessions}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>{title || 'Featured Listings'}</h2>
        </div>

        <div className={css.listingSlider}>
          <Slider {...sliderSettings}>
            {listings.map(l => (
              <div key={l?.id?.uuid} style={{ height: '100%' }}>
                <ListingCard
                  user={user}
                  className={css.listingCard}
                  listing={l}
                  setActiveListing={() => {}}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

ExploreSection.defaultProps = {
  sliderSettings: {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 4 } },
      { breakpoint: 1300, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 580, settings: { slidesToShow: 1.5, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
    ],
  },
};

export default ExploreSection;
